import { render } from "./form_5.vue?vue&type=template&id=fe165288"
import script from "./form_5.vue?vue&type=script&lang=js"
export * from "./form_5.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe165288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe165288', __exports__)) {
    console.log('reload')
    api.reload('fe165288', __exports__)
  }
  
  module.hot.accept("./form_5.vue?vue&type=template&id=fe165288", () => {
    console.log('re-render')
    api.rerender('fe165288', render)
  })

}


export default __exports__